import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/dashboard/Dashboard';
import Login from './pages/login/login';
import MemoPage from './pages/memo/memo';
import VideoLearningPage from './pages/videooverview/videooverview';
import VideoPage from './pages/videolist/videolist';
import SettingsPage from './pages/setting/setting';
import EmailVerification from './pages/verify/EmailVerification';
import DataDeletion from './pages/data-deletion/DataDeletion';
import LineCallback from './pages/auth/callback/line';
import LineEmailConsent from './pages/privacy/line-email-consent';
import PrivacyPolicy from './pages/privacy/privacy-policy';
import TermsOfService from './pages/privacy/terms-of-service';
// import Courses from './pages/courses/Courses';
// import Progress from './pages/progress/Progress';
// import Resources from './pages/resources/Resources';
// import Community from './pages/community/Community';
import './App.css';

const AppContent = () => {

  return (
    <div className="App">
      {/* {showHeader && <Header />} */}
      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<EmailVerification />} />
          <Route path="/auth/callback/line" element={<LineCallback />} />
          <Route path="/line-email-consent" element={<LineEmailConsent />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/memo" 
            element={
              <ProtectedRoute>
                <MemoPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/videos" 
            element={
              <ProtectedRoute>
                <VideoLearningPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/videolist" 
            element={
              <ProtectedRoute>
                <VideoPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/videos/:videoId" 
            element={
              <ProtectedRoute>
                <VideoLearningPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/setting" 
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/data-deletion" 
            element={
              <ProtectedRoute>
                <DataDeletion />
              </ProtectedRoute>
            } 
          />
          {/* <Route path="/courses" element={<ProtectedRoute><Courses /></ProtectedRoute>} />
          <Route path="/progress" element={<ProtectedRoute><Progress /></ProtectedRoute>} />
          <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>} />
          <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} /> */}
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
